const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const KeyboardEvents = require("../util/KeyboardEvents");

module.exports = createReactClass({
	displayName: "ScrollBar",

	propTypes: {
		axis: PT.oneOf(["x", "y"]).isRequired,
		areaSize: PT.number.isRequired,
		contentSize: PT.number.isRequired,
		contentPos: PT.number.isRequired,
		// Default to areaSize; always accessed via getBarSize.
		barSize: PT.number,
		barClassName: PT.string,
		barStyle: PT.object,

		thumbClassName: PT.string,
		thumbStyle: PT.object,
		minThumbSize: PT.number,

		useGlobalHotkeys: PT.bool,

		onChange: PT.func.isRequired,
		onKeySpecial: PT.func,
	},

	getInitialState: function() {
		return {
			isDragging: false,
		};
	},

	componentDidMount: function() {
		document.addEventListener("mousedown", this.handleGlobalMouseDown);
		document.addEventListener("mousemove", this.handleGlobalMouseMove);
		document.addEventListener("mouseup", this.handleGlobalMouseRelease);
		this.updateKeyListener(this.props.useGlobalHotkeys);
	},

	componentDidUpdate: function() {
		this.updateKeyListener(this.props.useGlobalHotkeys);
	},

	componentWillUnmount: function() {
		document.removeEventListener("mousedown", this.handleGlobalMouseDown);
		document.removeEventListener("mousemove", this.handleGlobalMouseMove);
		document.removeEventListener("mouseup", this.handleGlobalMouseRelease);
		this.updateKeyListener(false);
	},

	updateKeyListener: function(shouldListen) {
		if (shouldListen && !this._hasOnKeySpecial) {
			KeyboardEvents.onSpecial(this.handleSpecialKey);
			this._hasOnKeySpecial = true;
		} else if (!shouldListen && this._hasOnKeySpecial) {
			KeyboardEvents.offSpecial(this.handleSpecialKey);
			this._hasOnKeySpecial = false;
		}
	},

	// Calculations

	getBarSize: function() {
		const {barSize, areaSize} = this.props;
		return barSize || areaSize;
	},

	getThumbSize: function() {
		const {areaSize, contentSize, minThumbSize} = this.props;
		let size = (this.getBarSize() * areaSize) / contentSize;
		if (minThumbSize) {
			size = Math.max(size, minThumbSize);
		}
		return size;
	},

	getContentPosFromThumbPos: function(thumbPos) {
		const {areaSize, contentSize} = this.props;
		const barSize = this.getBarSize();
		const thumbSize = this.getThumbSize();
		if (barSize <= thumbPos) {
			return 0;
		}
		const t = thumbPos / (barSize - thumbSize);
		return t * (contentSize - areaSize);
	},

	getThumbPosFromContentPos: function(contentPos) {
		const {areaSize, contentSize} = this.props;
		const barSize = this.getBarSize();
		const thumbSize = this.getThumbSize();
		if (contentSize <= areaSize) {
			return 0;
		}
		const t = contentPos / (contentSize - areaSize);
		return t * (barSize - thumbSize);
	},

	// Event handlers

	handleSpecialKey: function(e, code) {
		const {axis, areaSize} = this.props;
		// Default scroll step for arrows
		const scrollStep = areaSize / 12;
		if (code === "home") {
			this.props.onChange(-Infinity);
		} else if (code === "end") {
			this.props.onChange(Infinity);
		} else if (code === "pageup") {
			this.props.onChange(-areaSize);
		} else if (code === "pagedown") {
			this.props.onChange(areaSize);
		} else if (code === "up" && axis === "y") {
			this.props.onChange(-scrollStep);
		} else if (code === "down" && axis === "y") {
			this.props.onChange(scrollStep);
		} else if (code === "left" && axis === "x") {
			this.props.onChange(-scrollStep);
		} else if (code === "right" && axis === "x") {
			this.props.onChange(scrollStep);
		} else {
			this.props.onKeySpecial && this.props.onKeySpecial(code);
		}
	},

	handleBarMouseDown: function(e) {
		const thumbRect = this.thumbDiv.getBoundingClientRect();
		let dir;
		let diff;
		if (this.props.axis === "y") {
			const thumbCenter = thumbRect.top + thumbRect.height / 2;
			dir = e.clientY < thumbCenter ? -1 : 1;
			diff = Math.abs(e.clientY - thumbCenter);
		} else {
			const thumbCenter = thumbRect.left + thumbRect.width / 2;
			dir = e.clientX < thumbCenter ? -1 : 1;
			diff = Math.abs(e.clientX - thumbCenter);
		}
		const delta = (diff / this.props.areaSize) * this.props.contentSize;
		this.props.onChange(delta * dir);
	},

	handleThumbMouseDown: function(e) {
		e.stopPropagation();
		this.lastDragPos = this.props.axis === "y" ? e.clientY : e.clientX;
		this.setState({isDragging: true});
	},

	handleGlobalMouseDown: function(e) {
		// If you are dragging the thumb and you right click, the mouse release
		// handler won't fire when the left button is released. This is an overly
		// cautious way to fix this bug.
		if (e.button > 0) {
			this.setState({isDragging: false});
		}
	},

	handleGlobalMouseMove: function(e) {
		if (!this.state.isDragging) {
			return;
		}
		const {axis, contentPos} = this.props;
		const barSize = this.getBarSize();
		const thumbSize = this.getThumbSize();
		// touch handlers must be added directly to the element so that
		// targetTouches works properly (not at the document level)
		const eventPositionInfo = e.targetTouches ? e.targetTouches[0] : e;
		const dragPos =
			axis === "y" ? eventPositionInfo.clientY : eventPositionInfo.clientX;
		const oldThumbPos = this.getThumbPosFromContentPos(contentPos);
		const newThumbPos = _.clamp(
			oldThumbPos + (dragPos - this.lastDragPos),
			0,
			barSize - thumbSize
		);
		const newContentPos = this.getContentPosFromThumbPos(newThumbPos);
		e.preventDefault();
		this.lastDragPos = dragPos;
		this.props.onChange(newContentPos - contentPos);
	},

	handleGlobalMouseRelease: function() {
		this.setState({isDragging: false});
	},

	// Rendering

	computeBarStyle: function() {
		const {axis} = this.props;
		const barSize = this.getBarSize();
		if (axis === "x") {
			return {
				width: barSize,
			};
		} else {
			return {
				height: barSize,
			};
		}
	},

	computeThumbStyle: function() {
		const {axis, contentPos} = this.props;
		const thumbSize = this.getThumbSize();
		const thumbPos = Math.round(this.getThumbPosFromContentPos(contentPos));
		if (axis === "x") {
			return {
				width: thumbSize,
				transform: "translateZ(0) translateX(" + thumbPos + "px)",
				// Support Safari 8
				WebkitTransform: "translateZ(0) translateX(" + thumbPos + "px)",
			};
		} else {
			return {
				height: thumbSize,
				transform: "translateZ(0) translateY(" + thumbPos + "px)",
				// Support Safari 8
				WebkitTransform: "translateZ(0) translateY(" + thumbPos + "px)",
			};
		}
	},

	render: function() {
		// baNoDrag class is used to prevent dragging by the scrollbar on draggable
		// modals (see Problem.jsx and Solution.jsx).
		const {barClassName, barStyle, thumbClassName, thumbStyle} = this.props;
		const barStyleWithDims = _.extend({}, barStyle, this.computeBarStyle());
		const thumbStyleWithDims = _.extend(
			{},
			thumbStyle,
			this.computeThumbStyle()
		);

		return (
			<div
				className={barClassName + " baNoDrag"}
				style={barStyleWithDims}
				onMouseDown={this.handleBarMouseDown}
				onTouchStart={this.handleBarMouseDown}
			>
				<div
					ref={ref => (this.thumbDiv = ref)}
					className={thumbClassName + " baNoDrag"}
					style={thumbStyleWithDims}
					onMouseDown={this.handleThumbMouseDown}
					onTouchStart={this.handleThumbMouseDown}
					onTouchMove={this.handleGlobalMouseMove}
				/>
			</div>
		);
	},
});
